import * as React from 'react';
import FormHelper from '@telia-front/form-helper';
import PropsChecker from '@telia-front/props-checker';
const TextAreaRows = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "TextareaRows", defaultValueName: "defaultRows", valueName: "rows", onChangeNames: "onChange", isComponentDisabled: props.isDisabled || props.isReadOnly },
        React.createElement(PropsChecker, { componentProps: props, componentName: "TextareaRows", defaultValueName: "defaultIsFocused", valueName: "isFocused", onChangeNames: ['onFocus', 'onBlur'] },
            React.createElement(TextAreaRowsInner, Object.assign({}, props)))));
};
export default TextAreaRows;
export class TextAreaRowsInner extends React.Component {
    constructor(props) {
        super(props);
        this.textarea = null;
        this.magicalCharacter = '‌'; // contains magical character &zwnj;
        this.prevSelectionStart = 0;
        this.prevSelectionEnd = 0;
        this.windowDidResize = () => {
            this.setState({
                txtRows: this.getTxtRows(this.rows),
            });
        };
        this.onFocus = () => {
            const done = () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            };
            if (this.props.isReadOnly) {
                return done();
            }
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: true,
                });
            }
            done();
        };
        this.onBlur = () => {
            if (typeof this.props.isFocused === 'undefined') {
                this.setState({
                    isFocused: false,
                });
            }
            if (this.props.onBlur) {
                this.props.onBlur();
            }
        };
        this.onKeyUp = (event) => {
            this.skipHelper(event.keyCode);
        };
        this.onClick = () => {
            this.skipHelper();
        };
        this.onChange = (event) => {
            if (!this.textarea) {
                return;
            }
            this.prevSelectionStart = this.textarea.selectionStart;
            this.prevSelectionEnd = this.textarea.selectionEnd;
            const strings = event.target.value.split('\n');
            const rowValues = strings.filter((item) => item !== this.magicalCharacter);
            if (typeof this.props.rows === 'undefined') {
                const rows = this.rowsCheckForHelpers(this.rows, rowValues);
                this.setState({ rows });
            }
            if (this.props.onChange) {
                this.props.onChange(rowValues);
            }
        };
        this.autosize = () => {
            if (this.textarea) {
                this.textarea.style.height = 'auto';
                this.textarea.style.height = `${this.textarea.scrollHeight}px`;
            }
        };
        this.state = {
            isFocused: props.defaultIsFocused || false,
            rows: this.defaultRows.map(({ value }) => ({ value })), // Exclude helpers for SSR
            txtRows: this.getTxtRows(this.defaultRows),
        };
        this.textareaClonedRows = [];
        this.textareaClonedRowsHelper = [];
    }
    componentDidMount() {
        window.addEventListener('resize', this.windowDidResize);
        if (typeof this.props.rows === 'undefined') {
            this.setState({
                rows: this.defaultRows,
            });
        }
        else {
            this.setState({
                txtRows: this.getTxtRows(this.defaultRows),
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.windowDidResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let prevRows = this.props.onChange && typeof this.props.rows !== 'undefined' ? prevProps.rows : prevState.rows;
        if (this.props.isDisabled || this.props.isReadOnly) {
            prevRows = typeof this.props.rows !== 'undefined' ? prevProps.rows : prevState.rows;
        }
        if (this.rows !== prevRows) {
            this.setState({
                txtRows: this.getTxtRows(this.rows),
            }, () => {
                if (!this.textarea) {
                    return;
                }
                /**
                 * Set back user last selection before new value, because we update textArea the selection gets updated too
                 */
                this.textarea.selectionStart = this.prevSelectionStart;
                this.textarea.selectionEnd = this.prevSelectionEnd;
            });
        }
        if (prevState.txtRows !== this.state.txtRows) {
            this.autosize();
        }
    }
    get defaultRows() {
        if (this.props.onChange && typeof this.props.rows !== 'undefined') {
            return this.props.rows;
        }
        else if (typeof this.props.defaultRows !== 'undefined') {
            return this.props.defaultRows;
        }
        return [];
    }
    get rows() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.rows !== 'undefined' ? this.props.rows : this.state.rows;
        }
        return this.props.onChange && typeof this.props.rows !== 'undefined' ? this.props.rows : this.state.rows;
    }
    get isFocused() {
        if (this.props.isReadOnly || this.props.isDisabled) {
            return typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
        }
        return this.props.onBlur && this.props.onFocus && typeof this.props.isFocused !== 'undefined' ? this.props.isFocused : this.state.isFocused;
    }
    get isInvalid() {
        return this.props.isInvalid || (!!this.props.helper && this.props.helper.type === 'error');
    }
    BEM() {
        const classArray = ['textarea-rows'];
        if (this.rows.length) {
            classArray.push('is-dirty');
        }
        if (this.rows.length > 9999) {
            classArray.push('is-wide');
        }
        if (this.props.isDisabled) {
            classArray.push('is-disabled');
        }
        if (this.props.isInvalid) {
            classArray.push('is-invalid');
        }
        if (this.isFocused) {
            classArray.push('is-focused');
        }
        if (this.props.hideLabel) {
            classArray.push('textarea-rows--no-label-' + this.props.hideLabel);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    itemBEM(helper) {
        const classArray = ['textarea-rows__item'];
        if (helper && helper.type) {
            classArray.push(`textarea-rows__item--${helper.type}`);
        }
        return classArray.join(' ');
    }
    rowsCheckForHelpers(oldRows, newRowValues) {
        const oldRowValues = oldRows.map(row => row.value);
        return newRowValues.map((value) => {
            const oldRowValuesIndex = oldRowValues.indexOf(value);
            if (oldRowValuesIndex !== -1) {
                const helper = oldRows[oldRowValuesIndex].helper;
                if (oldRows[oldRowValuesIndex].value === value) {
                    return { value, helper };
                }
            }
            return { value };
        });
    }
    skipHelper(keyCode) {
        if (!this.textarea) {
            return;
        }
        const currLineIndex = this.textarea.value.substr(0, this.textarea.selectionStart).split('\n').length - 1;
        if (this.state.txtRows[currLineIndex] === this.magicalCharacter) {
            if (keyCode === 40) {
                this.textarea.selectionStart = this.textarea.selectionEnd = this.textarea.selectionStart + 2;
            }
            else {
                this.textarea.selectionStart = this.textarea.selectionEnd = this.textarea.selectionStart - 2;
            }
            this.skipHelper(keyCode);
        }
    }
    getTxtRows(rows) {
        if (!rows.length) {
            return [];
        }
        return rows.reduce((acc, curr, index) => {
            acc.push(curr.value);
            if (this.textareaClonedRowsHelper) {
                const rowHelper = this.textareaClonedRowsHelper[index];
                if (rowHelper) {
                    const rowHeight = this.textareaClonedRows[index].getBoundingClientRect().height;
                    const rowTextComputedStyles = window.getComputedStyle(rowHelper, null);
                    if (rowTextComputedStyles.height) {
                        const rowTextHeight = +rowTextComputedStyles.height.split('px')[0];
                        if (rowTextHeight < Math.floor(rowHeight) && rowTextComputedStyles.lineHeight) {
                            const rowTextLineHeight = +rowTextComputedStyles.lineHeight.split('px')[0];
                            const realRowTextHeight = Math.round(rowTextHeight / rowTextLineHeight) * rowTextLineHeight;
                            const newRows = Math.floor(realRowTextHeight / rowTextLineHeight);
                            for (let i = 0; i < newRows; i += 1) {
                                acc.push(this.magicalCharacter);
                            }
                        }
                    }
                }
            }
            return acc;
        }, []);
    }
    getHelper(helper, key) {
        return (React.createElement("div", { className: "textarea-rows__helper", ref: (div) => (this.textareaClonedRowsHelper[key] = div) },
            React.createElement(FormHelper, Object.assign({ className: "textarea-rows__item-helper" }, helper))));
    }
    getClonedRow(row, key) {
        this.textareaClonedRowsHelper[key] = null;
        return (React.createElement("div", { className: this.itemBEM(row.helper), key: key, ref: (div) => (this.textareaClonedRows[key] = div) },
            React.createElement("div", { className: "textarea-rows__item-nr" }, key + 1),
            React.createElement("div", { className: "textarea-rows__item-text" },
                React.createElement("div", { className: "textarea-rows__value" }, row.value),
                row.helper && this.getHelper(row.helper, key))));
    }
    getClonedRows() {
        const rows = this.rows.map((row, key) => {
            return this.getClonedRow(row, key);
        });
        return React.createElement("div", { className: "textarea-rows__items" }, rows);
    }
    renderFormHelper(helper) {
        return React.createElement(FormHelper, Object.assign({}, helper, { className: "textarea-rows__form-helper", id: helper.id || `${this.props.id}-helper` }));
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("label", { htmlFor: this.props.id, className: "textarea-rows__label" }, this.props.label),
            React.createElement("div", { className: "textarea-rows__main" },
                React.createElement("div", { className: "textarea-rows__inner" },
                    React.createElement("div", { className: "textarea-rows__mirror" }, this.rows && this.getClonedRows()),
                    React.createElement("textarea", Object.assign({}, this.props.input, { id: this.props.id, readOnly: this.props.isReadOnly, className: "textarea-rows__input", rows: this.state.txtRows.length, ref: (textarea) => (this.textarea = textarea), value: this.state.txtRows && this.state.txtRows.join('\n'), onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onKeyUp: this.onKeyUp, onClick: this.onClick, disabled: this.props.isDisabled, "aria-invalid": this.isInvalid, "aria-describedby": this.props.helper ? this.props.helper.id || `${this.props.id}-helper` : undefined })))),
            this.props.helper && this.renderFormHelper(this.props.helper)));
    }
}
